/**
 * For reference: https://bulma.io/documentation/modifiers/typography-helpers/
 */

import classNames from 'classnames';

export interface ITypographyModifier {
	hasTextCentered?: boolean;
	hasTextJustified?: boolean;
	hasTextLeft?: boolean;
	hasTextRight?: boolean;

	isCapitalized?: boolean;
	isLowercase?: boolean;
	isUppercase?: boolean;
	isItalic?: boolean;
}

export function getTypographyModifierClasses(modifiers: ITypographyModifier) {
	return classNames(
		modifiers.hasTextCentered && 'has-text-centered',
		modifiers.hasTextJustified && 'has-text-justified',
		modifiers.hasTextLeft && 'has-text-left',
		modifiers.hasTextRight && 'has-textRight',

		modifiers.isCapitalized && 'is-capitalized',
		modifiers.isLowercase && 'is-lowercase',
		modifiers.isUppercase && 'is-uppercase',
		modifiers.isItalic && 'is-italic'
	);
}
